import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aseslabs',
  templateUrl: './aseslabs.component.html',
  styleUrls: ['./aseslabs.component.scss']
})
export class AseslabsComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
